var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchBox',{ref:"searchbox",attrs:{"label":_vm.retornaLabel(),"placeholder":"Busca Centro de Responsabilidade por Nome ou Código","funcaoBuscar":"getCentrosResponsabilidadeBox"},on:{"selected":_vm.handleSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }